<template>
  <div data-test="finder-jump-to-results">
    <RevChip
      :label="i18n(translations.jumpToResults)"
      size="small"
      :start-icon="IconArrowDownInCircleFilled"
      @click="jumpToResults"
    />
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevChip } from '@ds/components/Chip'
import { IconArrowDownInCircleFilled } from '@ds/icons/IconArrowDownInCircleFilled'

import translations from '../../Finder.translations'

const props = defineProps<{ toAnchorId: string }>()

const i18n = useI18n()

function jumpToResults() {
  document
    .getElementById(props.toAnchorId)
    ?.scrollIntoView({ behavior: 'smooth' })
}
</script>
